import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ServiceProvider } from '@sabstravtech/obtservices/base';
import {
  CarHireType,
  CarHireVehicleAvailibility,
  CarHireDetailRequestResponse,
  EnterpriseSearchService,
  ServiceType,
  CarHireIdentifiers,
  CarHireAdditionalInfoItem,
  WithSubscriptionComponent
} from '@sabstravtech/obtservices/angular';
import { BehaviorSubject } from 'rxjs';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-gmt-car-fare-rules-modal',
  templateUrl: './gmt-car-fare-rules-modal.html',
  styleUrls: ['./gmt-car-fare-rules-modal.scss'],
  standalone: false
})
export class GmtCarModalFareRulesComponent extends WithSubscriptionComponent implements OnInit {
  result: CarHireVehicleAvailibility = null;
  carTypeCodes: [string, string, CarHireType][];
  carHireAvailabilityDetailsObject: { [key: string]: CarHireDetailRequestResponse } = {};
  ServiceProvider = ServiceProvider;
  public carDetailLoadingStates: BehaviorSubject<boolean> = new BehaviorSubject(false);
  constructor(
    public modal: NgbActiveModal,
    public searchService: EnterpriseSearchService
  ) {
    super();
  }

  ngOnInit(): void {
    this.carTypeCodes = this.searchService.searches[ServiceType.Car].carTypeCodes;
    this.getCarDetails();
  }

  // -- Copied from CarsComponent
  getCarDetails(): void {
    if (
      !this.carHireAvailabilityDataExists(this.createKeyFromIdentifiers(this.result.identifiers))
    ) {
      this.getCarHireAvailabilityDetail(this.result);
    }
  }

  carHireAvailabilityDataExists(key: string): boolean {
    return key in this.carHireAvailabilityDetailsObject;
  }

  createKeyFromIdentifiers(identifiers: CarHireIdentifiers): string {
    return `${identifiers.vendor}_${identifiers.vehType}`;
  }

  updateCarHireAvailabilityDetailsObject(data: {
    key: string;
    value: CarHireDetailRequestResponse;
  }): void {
    this.carHireAvailabilityDetailsObject[data.key] = data.value;
  }

  getCarHireAvailabilityDetail(result: CarHireVehicleAvailibility): void {
    const { __typename, ...identifiers } = result.identifiers;
    if (result.source === ServiceProvider.TravelportCarHire) {
      const detailResult: CarHireDetailRequestResponse = {
        additionalInfo: result.displayRecord.additionalInfo,
        address: result.displayRecord.pickupLocation,
        identifiers: result.identifiers,
        vendor: result.displayRecord.vendor
      };
      detailResult.additionalInfo?.sort((a, b) =>
        a.name > b.name ? 1 : a.name === b.name ? 0 : -1
      );
      // move the number to the beginning of the array
      const phone = detailResult.additionalInfo?.find(
        (item: CarHireAdditionalInfoItem) => item.name === 'Contact Numbers'
      );
      detailResult.additionalInfo?.sort((a, b) => (a === phone ? -1 : b == phone ? 1 : 0));

      // store result in an object so we don't have to load the same data again if it's been previously loaded
      this.updateCarHireAvailabilityDetailsObject({
        key: this.createKeyFromIdentifiers(identifiers),
        value: detailResult
      });
    } else {
      this.subscribe(
        this.searchService.searches[ServiceType.Car].getCarHireAvailabilityDetail(
          {
            dropOffLocation: identifiers.dropOffLocation,
            dropOffDateTime: identifiers.dropOffDateTime,
            pickUpDateTime: identifiers.pickUpDateTime,
            pickUpExtendedLocationCode: identifiers.pickUpExtendedLocationCode,
            pickUpLocationCode: identifiers.pickUpLocationCode,
            pickUpLocationName: identifiers.pickUpLocationName,
            locator: '',
            rph: '',
            vehType: identifiers.vehType,
            vendor: identifiers.vendor,
            service: result.source,
            rateCode: result.displayRecord.rateCode
          },
          this.carDetailLoadingStates
        ),
        (result) => {
          result.additionalInfo.sort((a, b) => (a.name > b.name ? 1 : a.name === b.name ? 0 : -1));
          // move the number to the beginning of the array
          const phone = result.additionalInfo.find(
            (item: CarHireAdditionalInfoItem) => item.name === 'Contact Numbers'
          );
          result.additionalInfo.sort((a, b) => (a === phone ? -1 : b == phone ? 1 : 0));

          // store result in an object so we don't have to load the same data again if it's been previously loaded
          this.updateCarHireAvailabilityDetailsObject({
            key: this.createKeyFromIdentifiers(identifiers),
            value: result
          });
        }
      );
    }
  }

  getTypeForDisplayFromResult(result: CarHireVehicleAvailibility): string {
    const typeForDisplay = this.carTypeCodes.find(
      (carTypeCode) => carTypeCode[2] === result?.displayRecord?.vehicle?.type
    );
    if (typeForDisplay) {
      return typeForDisplay[1];
    }
  }

  getCo2Usage(result: CarHireVehicleAvailibility): string {
    return result?.co2PerItem?.toFixed(2) || '0.00';
  }

  // -- end Copied from CarsComponent
}

LightningModalTypes.GmtCarModalFareRulesComponent.component = GmtCarModalFareRulesComponent;
